module.exports = __webpack_public_path__ + "static/media/terms-icon.de147007.svg";